'use client';

import * as React from 'react';
import { cn } from '@lib/cn';

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  size?: 'sm'; // | 'base' | 'lg';
}

export function Separator({
  className,
  orientation = 'horizontal',
  size = 'sm',
  ...props
}: SeparatorProps) {
  const sizes = {
    sm: orientation === 'horizontal' ? 'h-px' : 'w-px',
    // base: orientation === 'horizontal' ? 'h-[2px]' : 'w-[2px]',
    // lg: orientation === 'horizontal' ? 'h-[4px]' : 'w-[4px]',
  };

  return (
    <div
      className={cn(
        'shrink-0 flex items-center justify-center',
        orientation === 'horizontal' ? 'w-full' : 'h-full self-stretch',
        className,
      )}
      {...props}
    >
      <span
        className={cn(
          'bg-[--base-border]',
          orientation === 'horizontal' ? 'w-full' : 'h-full',
          sizes[size],
        )}
      />
    </div>
  );
}
